import { getEffectiveDate } from "../../../../utils/effectiveDate";

export interface WeeklyCashMovementMonthOption {
  year: number;
  month: number;
  /** Stable key for controlled select: "{year}-{month}" */
  value: string;
  label: string;
}

/**
 * Twelve calendar months ending at the effective month (inclusive), newest first.
 * Aligns with weekly cash flow API allowed window.
 */
export function buildWeeklyCashMovementMonthOptions(): WeeklyCashMovementMonthOption[] {
  const anchor = getEffectiveDate();
  const formatter = new Intl.DateTimeFormat("en-IN", {
    month: "short",
    year: "numeric",
  });
  const out: WeeklyCashMovementMonthOption[] = [];

  for (let i = 0; i < 12; i++) {
    const d = new Date(anchor.getFullYear(), anchor.getMonth() - i, 1);
    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    out.push({
      year,
      month,
      value: `${year}-${month}`,
      label: formatter.format(d),
    });
  }

  return out;
}
